import type React from "react";
import { Box, Group, Progress, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { UploadProgressState } from "@hooks/useJobSubmit";

interface UploadProgressBarProps {
  uploadProgress: UploadProgressState;
}

const UploadProgressBar: React.FC<UploadProgressBarProps> = ({
  uploadProgress,
}) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Group justify="space-between" mb={4}>
        <Text size="xs" c="dimmed" truncate>
          {t("mappingServicePage.upload.uploading", {
            filename: uploadProgress.filename,
            defaultValue: `Uploading ${uploadProgress.filename}`,
          })}
        </Text>
        <Text size="xs" c="dimmed">
          {uploadProgress.percent}%
        </Text>
      </Group>
      <Progress
        value={uploadProgress.percent}
        size="xs"
        animated={uploadProgress.percent < 100}
      />
    </Box>
  );
};

export default UploadProgressBar;
